"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardIndex = DashboardIndex;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var nav_bar_1 = require("../../components/nav-bar");
var top_header_1 = require("../../components/top-header");
var hooks_1 = require("../../store/hooks");
function DashboardIndex() {
    var isNavbarCollapsed = (0, hooks_1.useAppSelector)(function (state) { return state.common; }).isNavbarCollapsed;
    var marginClass = isNavbarCollapsed ? "ml-16 md:ml-20" : "ml-64";
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex h-screen w-full", children: [(0, jsx_runtime_1.jsx)(nav_bar_1.NavBar, {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-1 flex-col transition-all duration-300 ".concat(marginClass), children: [(0, jsx_runtime_1.jsx)(top_header_1.TopHeader, {}), (0, jsx_runtime_1.jsx)("main", { className: "flex-1 overflow-auto bg-gray-50 p-2 pt-18 md:p-6 md:pt-20", children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) })] })] }));
}
